import React, { useEffect, useRef, useState } from "react";

export default function FpsMonitor({ style, interval = 500 }) {
  const [fps, setFps] = useState("--");

  const [visible, setVisible] = useState(true);
  
  const isDraggingRef = useRef(false);
  const [isDragging, setIsDragging] = useState(false);

  const [position, setPosition] = useState({ x: 10, y: 10 });
  const dragStartPos = useRef({ x: 0, y: 0 });
  const frames = useRef(0);
  const lastFpsTime = useRef(0);
  const fpsHistory = useRef([]);
  const monitorRef = useRef(null);
  const lastClickTime = useRef(0); 

  // FPS 计算逻辑
  useEffect(() => {
    let animationId;
    lastFpsTime.current = performance.now();

    const loop = (now) => {
      frames.current += 1;
      if (now - lastFpsTime.current >= interval) {
        const currentFps = (frames.current * 1000) / (now - lastFpsTime.current);
        fpsHistory.current = [...fpsHistory.current.slice(-5), currentFps];
        const smoothedFps = (
          fpsHistory.current.reduce((a, b) => a + b, 0) / fpsHistory.current.length
        ).toFixed(1);
        setFps(smoothedFps);
        frames.current = 0;
        lastFpsTime.current = now;
      }
      animationId = requestAnimationFrame(loop);
    };

    animationId = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(animationId);
  }, [interval]);

  // 拖拽逻辑
  const handleMouseDown = (e) => {
    e.preventDefault(); 

    // 检测双击
    const now = Date.now();
    if (now - lastClickTime.current < 300) {
      setVisible(false); 
      return;
    }
    lastClickTime.current = now;

    isDraggingRef.current = true;
    setIsDragging(true);
    dragStartPos.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!isDraggingRef.current) return;

    setPosition({
      x: e.clientX - dragStartPos.current.x,
      y: e.clientY - dragStartPos.current.y
    });
    
  };

  const handleMouseUp = () => {
    isDraggingRef.current = false;
    setIsDragging(false);
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  // 动态颜色
  const color = fps === "--" ? "#0f0" : fps >= 50 ? "#0f0" : fps >= 30 ? "#ff0" : "#f00";

  if (!visible) return null;
  return (
    <div
      ref={monitorRef}
      onMouseDown={handleMouseDown}
      style={{
        position: "fixed",
        left: `${position.x}px`,  
        top: `${position.y}px`,
        background: "rgba(0,0,0,0.7)",
        color,
        padding: "6px 12px",
        borderRadius: 6,
        fontFamily: "monospace",
        fontSize: 16,
        zIndex: 9999,
        cursor: isDragging ? "grabbing" : "move",
        userSelect: "none",
        touchAction: "none", 
        ...style,
      }}
    >
      FPS: {fps}
    </div>
  );
}